import { selectSearchRequestQuery } from "../../search/domains/selectors/shared";
import isFacetedNavPageHelper from "../../../../helpers/isFacetedNavPage";

const isFacetedNavPage = (state) => {
  const { category } = state;
  if (!category) {
    return false;
  }

  const seoImportantFacets = category.details?.seoImportantFacets;
  const { refine } = selectSearchRequestQuery(state);

  return isFacetedNavPageHelper({ seoImportantFacets, refine });
};

export default isFacetedNavPage;
